/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const EntityBalanceReportUpdatePage = lazyLoad(
  () => import('./index'),
  module => module.EntityBalanceReportUpdatePage
);
